// extracted by mini-css-extract-plugin
export default {"wrapper":"inviteYourFriends_wrapper__N+54q","content":"inviteYourFriends_content__n70J4","link":"inviteYourFriends_link__+7oHT","contentLeft":"inviteYourFriends_contentLeft__iUBmD"};